export { default as DuplicateSolidIcon } from './DuplicateSolidIcon';
